export default "__VITE_ASSET__0528eda4__"